function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.6504 4.35938C11.2027 4.35938 11.6504 4.80709 11.6504 5.35938V9.35938H15.6504C16.2027 9.35938 16.6504 9.80709 16.6504 10.3594C16.6504 10.9117 16.2027 11.3594 15.6504 11.3594H11.6504V15.3594C11.6504 15.9117 11.2027 16.3594 10.6504 16.3594C10.0981 16.3594 9.65039 15.9117 9.65039 15.3594V11.3594H5.65039C5.09811 11.3594 4.65039 10.9117 4.65039 10.3594C4.65039 9.80709 5.09811 9.35938 5.65039 9.35938H9.65039V5.35938C9.65039 4.80709 10.0981 4.35938 10.6504 4.35938Z",
  fill: "#252733"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.65039 20.3594C1.99354 20.3594 0.650391 19.0162 0.650391 17.3594V3.35938C0.650391 1.70252 1.99354 0.359375 3.65039 0.359375H17.6504C19.3072 0.359375 20.6504 1.70252 20.6504 3.35938V17.3594C20.6504 19.0162 19.3072 20.3594 17.6504 20.3594H3.65039ZM2.65039 17.3594C2.65039 17.9117 3.09811 18.3594 3.65039 18.3594H17.6504C18.2027 18.3594 18.6504 17.9117 18.6504 17.3594V3.35938C18.6504 2.80709 18.2027 2.35938 17.6504 2.35938H3.65039C3.09811 2.35938 2.65039 2.80709 2.65039 3.35938V17.3594Z",
  fill: "#252733"
});

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.68be53b0.svg";
export { ForwardRef as ReactComponent };